module.exports = __webpack_public_path__ + "static/img/IMG_20160821_140325.62cd3cab.jpg";